import * as core from '../../../../../../../core'

import { query } from './touch-and-open-assistant.query'

export const RESOURCE = {
  payload: {
    alias: 'playground.touch-and-open-assistant',
    description:
      'Marks the Goal record as reviewed via a real backend DMS mutation, ' +
      'then opens the assistant slideout authorized to retrieve that record',
    name: 'Playground - Touch Goal & Open Assistant',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
